function VerticalTabs() {
  const components = Array.from(document.querySelectorAll(".c-vertical-tabs"));
  components.forEach((parent) => {
    setupVerticalTabs(parent);
  });
}

function setupVerticalTabs(parent) {
  const controls = Array.from(
    parent.querySelectorAll(".c-vertical-tabs__control"),
  );
  const contents = Array.from(parent.querySelectorAll(".c-vertical-tab"));
  const persist = parent.dataset.persist === "true";

  if (!controls.length || !contents.length) return;

  controls.forEach((control, index) => {
    const content = contents[index];
    if (!content) return;

    const isActive = control.classList.contains(
      "c-vertical-tabs__control--active",
    );

    // Fallback: set ARIA attributes if not already present in HTML
    control.setAttribute("role", "tab");
    control.setAttribute("aria-selected", isActive ? "true" : "false");
    control.setAttribute("aria-expanded", isActive ? "true" : "false");
    control.id ||= `vertical-tab-${index + 1}-tab`;
    control.setAttribute("aria-controls", content.id);
    control.tabIndex = isActive ? 0 : -1;

    content.setAttribute("role", "tabpanel");
    content.setAttribute("aria-labelledby", control.id);
    content.inert = !content.classList.contains("c-vertical-tab--active");

    control.addEventListener("keydown", (e) => handleKeydown(e, controls));
  });

  controls.forEach((control) => {
    control.addEventListener(
      "click",
      controlClick(controls, contents, persist),
    );
  });

  if (persist && window.location.hash) {
    const control = parent.querySelector(`[href="${window.location.hash}"]`);
    if (control) control.dispatchEvent(new Event("click"));
  }
}

function handleKeydown(event, controls) {
  const key = event.key;
  const current = event.currentTarget;
  let index = controls.indexOf(current);

  if (
    ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(
      key,
    )
  ) {
    event.preventDefault();

    if (key === "ArrowUp" || key === "ArrowLeft")
      index = (index - 1 + controls.length) % controls.length;
    if (key === "ArrowDown" || key === "ArrowRight")
      index = (index + 1) % controls.length;
    if (key === "Home") index = 0;
    if (key === "End") index = controls.length - 1;

    controls[index].focus();
    controls[index].click();
  }
}

function controlClick(controls, contents, persist) {
  return (event) => {
    const control = event.currentTarget;

    const contentId = control.getAttribute("aria-controls");
    const content = contents.find((x) => x.id === contentId);

    if (!content) return;

    event.preventDefault();

    if (persist && control.getAttribute("href")) {
      history.pushState(null, null, control.getAttribute("href"));
    }

    controls.forEach((c) => {
      const isActive = c === control;
      c.classList.toggle("c-vertical-tabs__control--active", isActive);
      c.setAttribute("aria-selected", isActive ? "true" : "false");
      c.setAttribute("aria-expanded", isActive ? "true" : "false");
      c.tabIndex = isActive ? 0 : -1;
    });

    contents.forEach((c) => {
      const isActive = c === content;
      c.classList.toggle("c-vertical-tab--active", isActive);
      c.inert = !isActive;
    });

    if (control.scrollIntoView) {
      control.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };
}

export default VerticalTabs;
